
export default [
  {
    headerName: 'Product',
    field: 'ProductCode',
    filter: 'agTextColumnFilter',
    tooltipField: 'ProductCode',
    minWidth: 125,
  },
  {
    headerName: 'RemoteSignaturePercentage',
    field: 'RemoteSignature_PC',
    filter: 'agTextColumnFilter',
    tooltipValueGetter: (params) => {
      if (params.value == null) return '';
      return parseFloat(params.value).toFixed(2) + '%';
    },
    minWidth: 75,
    valueFormatter: (params) => {
      if (params.value == null) return '';
      return parseFloat(params.value).toFixed(2);
    },
  },
  {
    headerName: 'ManualSignaturePercentage',
    field: 'ManualSignature_PC',
    filter: 'agTextColumnFilter',
    tooltipValueGetter: (params) => {
      if (params.value == null) return '';
      return parseFloat(params.value).toFixed(2) + '%';
    },
    minWidth: 75,
    valueFormatter: (params) => {
      if (params.value == null) return '';
      return parseFloat(params.value).toFixed(2);
    },
  },
  {
    headerName: 'AffinityRemoteSignaturePercentage',
    field: 'AffinityRemoteSignature_PC',
    filter: 'agTextColumnFilter',
    tooltipValueGetter: (params) => {
      if (params.value == null) return '';
      return parseFloat(params.value).toFixed(2) + '%';
    },
    minWidth: 75,
    valueFormatter: (params) => {
      if (params.value == null) return '';
      return parseFloat(params.value).toFixed(2);
    },
  },
  {
    headerName: 'AffinityManualSignaturePercentage',
    field: 'AffinityManualSignature_PC',
    filter: 'agTextColumnFilter',
    tooltipValueGetter: (params) => {
      if (params.value == null) return '';
      return parseFloat(params.value).toFixed(2) + '%';
    },
    minWidth: 75,
    valueFormatter: (params) => {
      if (params.value == null) return '';
      return parseFloat(params.value).toFixed(2);
    },
  },
];

